import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "../SectionHeading";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
};

/**
 * The step-by-step process grid on a service detail page.
 *
 * Illustrations come from public/assets/certification-process — the set shared
 * with the homepage process section and the Certifications page. Nothing new
 * is sourced per page.
 */
const ServiceProcessSection = ({ id, title, subtitle, steps, tone = "light" }) => (
  <section
    className={`${tone === "light" ? "bg-white" : "bg-gray-50"} py-14 lg:py-20`}
    aria-labelledby={id}
  >
    <div className="brand-col">
      <SectionHeading id={id} title={title} subtitle={subtitle} />
      <motion.ol
        className="grid list-none grid-cols-1 gap-6 p-0 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        variants={{ visible: { transition: { staggerChildren: 0.07 } } }}
      >
        {steps.map((step) => (
          <motion.li
            key={step.number}
            variants={cardVariants}
            className="brand-card items-center p-6 text-center lg:p-8"
          >
            <span className="flex h-24 items-center justify-center">
              <img
                src={step.image}
                alt=""
                aria-hidden="true"
                loading="lazy"
                className="h-full w-auto max-w-full object-contain"
              />
            </span>
            <h3 className="mt-4 text-base lg:text-lg font-bold text-gray-900">
              {step.title}
            </h3>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-gray-600">
              {step.description}
            </p>
          </motion.li>
        ))}
      </motion.ol>
    </div>
  </section>
);

export default ServiceProcessSection;
